
export default {
  data () {
    return {
      hotelBrands: [
        { src: '/images/hotels/logo_agoda.png', alt: 'Agoda', artifactFix: true },
        { src: '/images/hotels/logo_booking.png', alt: 'Booking.com', artifactFix: true },
        { src: '/images/hotels/logo_expedia.png', alt: 'Expedia' },
        { src: '/images/hotels/logo_hotelscom.png', alt: 'Hotels.com' },
        { src: '/images/hotels/logo_hotelscombined.png', alt: 'HotelsCombined' },
        { src: '/images/hotels/logo_hotwire.png', alt: 'Hotwire' },
        { src: '/images/hotels/logo_kayak.png', alt: 'Kayak', artifactFix: true },
        { src: '/images/hotels/logo_priceline.png', alt: 'Priceline' },
        { src: '/images/hotels/logo_tripadvisor.png', alt: 'Tripadvisor' },
        { src: '/images/hotels/logo_trivago.png', alt: 'Trivago', artifactFix: true }
      ],
    }
  },
  computed: {
    siteType () {
      return this.$store.state.siteType
    },
    backgroundImage () {
      return `url(/images/heroes/${this.$store.state.site}.jpg)`
    },
    heroTitle () {
      return this.$route.query.title || null
    }
  }
}
